export const NO_ACCOUNT_VALUE = 'no-account' as const;
